<template>
  <section>
    <h5>{{ title }}</h5>
    <div class="row">
      <!-- Search -->
      <div class="col-md-3">
        <dt-search
          class="mt-2"
          name="search"
          label=""
          placeholder="Search"
          v-model.trim="currentSearchTerm"
          @keyup="search"
          :readonly="$loading.isLoading('getContacts')"
        />
      </div>
      <!-- Filter -->
      <div
        class="col-md-4"
        v-show="showFilter"
      >
        <div class="row mt-2">
          <div class="col-md-2 custom-filter">
            <i class="fas fa-filter filterIcon"></i>
            <a
              href="#"
              @click="clearFilter"
            ><i class="fas fa-times filterIcon iconClear"></i></a>
          </div>
          <select
            v-model="currentFilterBy"
            class="col-md-10 custom-select"
          >
            <option
              v-for="(option, index) of filterOptions"
              :value="option.value"
              :key="index"
            >
              {{option.name}}
            </option>
          </select>
        </div>
      </div>
      <!-- Placeholder -->
      <div class="col-md-5">
        <div class="row mt-2">
          <div>
            <button
              class="btn btn-primary"
              @click="addContact"
            >Add</button>
          </div>
          <div
            class="ml-2"
            v-show="isChecked"
          >
            <button
              class="btn btn-primary"
              @click="mergeContacts"
            >Merge</button>
          </div>
        </div>
      </div>
    </div>
    <div class="row">
      <!-- Pagination -->
      <div class="col-md-2">
        <dt-select
          v-model="currentPageSize"
          :options="pageSizes"
          label=""
          name="pageSize"
          :disabled="$loading.isLoading('getContacts')"
        />
      </div>
      <div class="col-md-3">
      </div>
      <div class="col-md-5">
        <nav>
          <dt-paginate
            v-model="page"
            :page-count="pages"
            @change="change"
          />
        </nav>
      </div>
      <div class="col-md-2 text-right">
        <h5
          class="mt-2 mr-2"
          title="# items"
        >{{ numItems }}</h5>
        <span class="custom-items">items</span>
      </div>
    </div>
  </section>
</template>
<script>
import { mapGetters, mapActions } from 'vuex'
import DtSearch from '@/components/utilities/form/dt-search'
import DtSelect from '@/components/utilities/form/dt-select'
import DtPaginate from '@/components/utilities/paginate/dt-paginate'
export default {
  name: 'contact-listing-header',
  components: {
    DtSearch,
    DtSelect,
    DtPaginate
  },
  props: {
    pages: Number,
    pageSizes: Array,
    pageSize: Number,
    searchTerm: String,
    filterBy: Number,
    userRole: String,
    numItems: Number,
    showFilter: {
      type: Boolean,
      default: true
    },
    title: {
      type: String,
      default: 'Contacts'
    }
  },
  data() {
    return {
      page: 1,
      isChecked: false
    }
  },
  watch: {
    isContactChecked() {
      this.isChecked = false
      if (this.isContactChecked) {
        this.isChecked = true
      }
    }
  },
  computed: {
    ...mapGetters('contacts', ['filterOptions', 'isContactChecked']),
    ...mapGetters('lookups', ['lookups']),
    currentPageSize: {
      get() {
        return this.pageSize
      },
      set(value) {
        this.page = 1
        this.setPageSize(value)
        this.search('')
      }
    },
    currentFilterBy: {
      get() {
        return this.filterBy
      },
      set(value) {
        this.page = 1
        this.setFilterBy(value)
        this.search('')
      }
    },
    currentSearchTerm: {
      get() {
        return this.searchTerm
      },
      set(value) {
        this.setSearchTerm(value)
      }
    }
  },
  methods: {
    ...mapActions('contacts', ['setPageSize', 'setFilterBy', 'setSearchTerm']),
    change(page) {
      this.search(this.currentSearchTerm)
    },
    search(text) {
      let _search = ''
      if (text === undefined || text === null) {
        _search = this.currentSearchTerm
      } else {
        _search = text
        this.currentSearchTerm = text
      }
      this.$emit('search', this.page, _search)
    },
    addContact() {
      this.$emit('add')
    },
    mergeContacts() {
      this.$emit('merge')
    },
    clearFilter() {
      this.currentFilterBy = ''
    }
  }
}
</script>
<style scoped>
.filterIcon {
  font-size: 1.2em;
}
.iconClear {
  color: red;
}
.filterListing {
  float: left;
}
.custom-items {
  right: 10px;
  top: -10px;
  position: relative;
}
.custom-filter {
  top: 8px;
  display: inline;
  text-align: right;
}
</style>



// WEBPACK FOOTER //
// src/components/contacts/listings/contact-listing-header.vue